import React from "react";
import {
  CardContainer,
  CardHeader,
  PlayerImage,
  PlayerInfo,
  PlayerName,
  PlayerMeta,
  ReportText,
  CardFooter,
} from "./ScouteCard.style";
import { MdOutlineAccessTime } from "react-icons/md";

const ScoutCard = ({ name, report, image, date }) => {
  return (
    <CardContainer>
      <CardHeader>
        {image && <PlayerImage src={image} alt={name} />}
        <PlayerInfo>
          <PlayerName>{name}</PlayerName>
          <PlayerMeta>
            <MdOutlineAccessTime />
            <span>{date}</span>
          </PlayerMeta>
        </PlayerInfo>
      </CardHeader>
      <ReportText>{report}</ReportText>
      <CardFooter>
        <span
          style={{
            width: "96px",
            height: "32px",
            textAlign: "end",
            fontSize: "16px",
            fontWeight: "700",
            color: "#022142",
          }}
        >
          Read More
        </span>
      </CardFooter>
    </CardContainer>
  );
};

export default ScoutCard;
